<template>
  <div>
    <div class="field-of-fields">
      <label class="top-label">Who do you want to email blast?</label>
      <div class="form-check" v-for="(audienceOption, index) in audiences" v-bind:key="'Audience'+index">
        <input class="form-check-input" type="radio" :id="'Audience'+index" :value="audienceOption" v-model="audience">
        <label class="form-check-label ml-1" :for="'Audience'+index">
          {{ audienceOption }}
        </label>
      </div>

      <div v-if="audience === 'Candidates' || audience === 'Clients'">
        <label>Do you want to blast to particular statuses?</label>
        <small class="small-label-help-text">You can select multiple statuses, or leave blank to blast to all statuses</small>
        <div class="form-check" v-for="(status, statusindex) in statusOptions" :key="'Status'+statusindex">
          <input class="form-check-input" type="checkbox" :value="status" v-model="statuses"/>
          <label class="form-check-label">{{ status }}</label>
        </div>
      </div>

      <div v-if="audience === 'Candidates'">
        <label for="">Do you want to blast to only nannies in certain cities?</label>
        <!-- <multiselect
          v-model="cityFilters"
          :options="cities"
          :multiple="true"
          :searchable="true"
          :close-on-select="true"
          :show-labels="false"
          placeholder="Select City(ies)"
        ></multiselect> -->
        <small class="small-label-help-text">You can select multiple cities, or leave blank to blast to all locations</small>
        <div class="form-check" v-for="(city, cityindex) in $store.getters.cities" :key="'City'+cityindex">
          <input class="form-check-input" type="checkbox" :value="city" v-model="cityFilters"/>
          <label class="form-check-label">{{ city }}</label>
        </div>
      </div>

      <div v-if="audience">
        <hr>
        <h4>Blasting to {{ userList.length }} users!</h4>
        <button class="mylisting-button dark-button mt-3" @click="viewMailingList()">View Blast List</button>
        <hr>
        <!-- <div v-if="audience === 'Individual'">
          <label>Sender Email</label>
          <input type="text" class="form-control" placeholder="" v-model="fromEmail">
        </div> -->
        <label>Subject</label>
        <input type="text" class="form-control" placeholder="" v-model="subject">
        <!-- <label>Sender Email</label>
        <small class="small-label-help-text">Who will the emails come from?</small>
        <input type="text" class="form-control" placeholder="" v-model="fromEmail"> -->
        <label>Body</label>
        <small class="small-label-help-text">Hold shift+enter for a newline without a double space</small>
        <!-- <textarea rows="14" v-model="body" class="form-control"></textarea> -->
        <div class="editor">
          <!-- <Modal ref="ytmodal" @onConfirm="addCommand" /> -->
          <editor-menu-bar :editor="emailEditor" v-slot="{ commands, isActive }" class="mb-1">
            <div class="menubar">
              <button class="btn btn-grey btn-sm menubar__button" :class="{ 'is-active': isActive.bold() }" @click.prevent="commands.bold">
                <strong>B</strong>
              </button>
              <button class="btn btn-grey btn-sm menubar__button" :class="{ 'is-active': isActive.italic() }" @click.prevent="commands.italic">
                <i>Italics</i>
              </button>
              <button class="btn btn-grey btn-sm menubar__button" :class="{ 'is-active': isActive.underline() }" @click.prevent="commands.underline">
                <u>U</u>
              </button>
              <!-- <button class="btn btn-grey btn-sm menubar__button" @click.prevent="showImagePrompt(commands.image)">
                Image
              </button> -->
              <!-- <button class="btn btn-grey btn-sm menubar__button" @click.prevent="uploadImage(commands.image)">
                Image
              </button> -->
              <!-- https://github.com/scrumpy/tiptap/issues/89 -->
              <!-- https://codesandbox.io/s/j3p0z44155 -->
              <!-- <button class="btn btn-grey btn-sm menubar__button" @click.prevent="openModal(commands.image);">
                Image
              </button> -->
              <button class="btn btn-grey btn-sm menubar__button" :class="{ 'is-active': isActive.paragraph() }" @click.prevent="commands.paragraph">
                p
              </button>
              <button class="btn btn-grey btn-sm menubar__button" :class="{ 'is-active': isActive.heading({ level: 3 }) }" @click.prevent="commands.heading({ level: 2 })">
                H1
              </button>
              <button class="btn btn-grey btn-sm menubar__button" :class="{ 'is-active': isActive.heading({ level: 4 }) }" @click.prevent="commands.heading({ level: 3 })">
                H2
              </button>
              <button class="btn btn-grey btn-sm menubar__button" :class="{ 'is-active': isActive.heading({ level: 5 }) }" @click.prevent="commands.heading({ level: 4 })">
                H3
              </button>
              <button class="btn btn-grey btn-sm menubar__button" :class="{ 'is-active': isActive.bullet_list() }" @click.prevent="commands.bullet_list">
                List
              </button>
              <button class="btn btn-grey btn-sm menubar__button" :class="{ 'is-active': isActive.ordered_list() }" @click.prevent="commands.ordered_list">
                1. 2. 3...
              </button>
              <!-- <button class="btn btn-grey btn-sm menubar__button" :class="{ 'is-active': isActive.blockquote() }" @click.prevent="commands.blockquote">
                ""
              </button> -->
              <button class="btn btn-grey btn-sm menubar__button" :class="{ 'is-active': isActive.horizontal_rule() }" @click.prevent="commands.horizontal_rule">
                ---
              </button>
              <!-- <button class="btn btn-grey btn-sm menubar__button" :class="{ 'is-active': isActive.undo() }" @click.prevent="commands.undo">
                Undo
              </button>
              <button class="btn btn-grey btn-sm menubar__button" :class="{ 'is-active': isActive.redo() }" @click.prevent="commands.redo">
                Redo
              </button> -->
            </div>
          </editor-menu-bar>
          <editor-content class="editor__content" :editor="emailEditor" />
        </div>
        <hr>
        <button @click="sendEmailBlast()" class="mylisting-button dark-button">Send Blast</button>
      </div>
    </div>



    <!-- <button class="mylisting-button dark-button mt-4" @click="showNewEmailModal()">Send New Email Blast</button> -->
    <!-- <div v-for="(email, index) in emailBlasts" :key="'Email'+index">
      <h3>Subject: {{ email.subject }} <img src="../../../assets/img/icons/edit_icon_simple.svg" style="width: 15px;"></h3>
      <h5>Statuses: {{ email.multiselect }}</h5>
      <p class="">Sender Email: {{ email.from_email }}</p>
      <p>Recipients: {{ email.recipients }}</p>
      <hr>
    </div> -->

    <!-- <modal name="new-email-modal" width="80%" height="auto" :scrollable='true' style="z-index: 9999;">
      <div class="p-5">
        <div class="field-of-fields">
          <label>Select User Type</label>
          <div class="" style="">
            <multiselect
              v-model="selector1"
              :options="selector1Options"
              :multiple="false"
              :searchable="false"
              :close-on-select="true"
              :show-labels="false"
              placeholder="Select Type"
            ></multiselect>
          </div>
          <label for="">Select by Status</label>
          <div class="input-group mt-1 mb-3" style="">
            <select class="form-control" v-model="status">
              <option v-for="(statusOption, index) in statuses" :key="index">{{ statusOption }}</option>
            </select>
            <button class="btn btn-secondary" @click="getUsersByStatus()" v-if="status">Get Users</button>
          </div>

          <label style="margin-top: 0;">Recipients</label>
          <input type="text" class="form-control" placeholder="Select a status to populate this list" v-model="emails">

          <label>Subject</label>
          <input type="text" class="form-control" placeholder="" v-model="subject">
          <label>Body</label>
          <textarea rows="14" v-model="body" class="form-control"></textarea>
          <p>Use [*fname*] for first name.</p>
          <label>Sender Email</label>
          <input type="text" class="form-control" placeholder="" v-model="fromEmail">
          <hr>

        </div>
        <hr>
        <button class="mylisting-button secondary-button" @click="$modal.hide('new-email-modal')" style="">Close</button>
        <button class="mylisting-button dark-button" style="float: right;" @click="sendEmail()">Save Email</button>
      </div>
    </modal> -->

    <modal name="blastoff-modal" width="80%" height="auto" :scrollable='true' style="z-index: 9999;">
      <div class="p-5">
        <h2>Blast Off!</h2>
        <h4>Your emails are on their way! It may take a few minutes, depending on how many are being sent. They will appear in the general email log and the individual user's email logs as they are sent.</h4>
        <hr>
        <button class="mylisting-button secondary-button" @click="$modal.hide('blastoff-modal')" style="">Done</button>
      </div>
    </modal>

    <modal name="view-mailing-list-modal" width="80%" height="auto" :scrollable='true' style="z-index: 9999;">
      <div class="p-5">
        <h2>Blast List</h2>
        <hr>
        <div v-for="user in userList" :key="user.id">
          <p>{{ user.first_name }} {{ user.last_name }} - {{ user.email }}</p>
        </div>
        <hr>
        <button class="mylisting-button secondary-button" @click="$modal.hide('view-mailing-list-modal')" style="">Done</button>
      </div>
    </modal>

    <!-- <modal name="delete-item-modal" width="80%" height="auto" :scrollable='true' style="z-index: 9999;">
      <div class="p-5">
        <h4>Are you sure you want to remove {{ item.label }}?</h4>
        <hr>
        <button class="mylisting-button secondary-button" @click="$modal.hide('delete-item-modal')" style="">Cancel</button>
        <button class="mylisting-button danger-button" @click="deleteItem()" style="float: right;">Delete</button>
      </div>
    </modal>

    <modal name="deleted-modal" width="50%" height="auto" :scrollable='true' style="z-index: 9999;">
      <div class="p-5">
        <h4>Item Deleted.</h4>
        <hr>
        <button class="mylisting-button secondary-button" @click="$modal.hide('deleted-modal')" style="">Close</button>
      </div>
    </modal> -->

  </div>
</template>

<script>
// Feature Ideas:
// Show a list of everyone who will receive the email, and make it possible to remove and add people
// Make it possible to add a list of individual emails
// Load email templates
// Create mailing lists
// Add a select all button for the status list (maybe deselect all)

import axios from 'axios'

// https://github.com/scrumpy/tiptap/blob/master/examples/Components/Routes/Export/index.vue
// Import the editor
import { Editor, EditorContent, EditorMenuBar } from 'tiptap'
// import Icon from 'Components/Icon'
import {
  Blockquote,
  CodeBlock,
  HardBreak,
  Heading,
  HorizontalRule,
  OrderedList,
  BulletList,
  ListItem,
  TodoItem,
  TodoList,
  Bold,
  Code,
  Italic,
  Link,
  Strike,
  Underline,
  History,
  Image, // https://github.com/scrumpy/tiptap/blob/master/examples/Components/Routes/Images/index.vue
} from 'tiptap-extensions'

export default {
  components: {
    EditorContent,
    EditorMenuBar,
    // Datepicker, // https://www.npmjs.com/package/vuejs-datepicker
  },
  data() {
    return {
      users: [],
      candidates: [],
      employers: [],

      audiences: [
        'Everyone',
        'Candidates',
        'Clients',
        // 'Individuals',
      ],
      audience: '',
      statuses: [],
      // cities: ['Chicago', 'DC Metro Area'],
      cities: [],
      cityFilters: [],

      subject: '',
      body: '',
      fromEmail: this.$store.getters.agencyFromEmail,
    }
  },
  computed: {
    statusOptions() {
      // if (this.selector1 == 'Candidate') {
      if (this.audience == 'Candidates') {
        return this.$store.getters.candidateStatuses
      }
      else if (this.audience == 'Clients') {
        return this.$store.getters.employerStatuses
      }
      else {
        return []
      }
    },
    userList() {
      // This list of users that will receive the email blast
      let userList = this.users
      if (this.audience === 'Candidates') {
        userList = userList.filter(user => {
          return user.is_candidate
        })
      }
      else if (this.audience === 'Clients') {
        userList = userList.filter(user => {
          return user.is_employer
        })
      }
      // Want to make sure the audience actually is Candidates or Clients, in case they selected some statuses, and then switch to a different audience selection
      if ((this.audience === 'Candidates' || this.audience === 'Clients') && this.statuses.length) {
        userList = userList.filter(user => {
          return this.statuses.includes(user.status)
        })
      }
      if (this.cityFilters.length > 0) {
        userList = userList.filter(user => {
          // return this.cityFilters.includes(user.city.toLowerCase())
          return this.cityFilters.includes(user.selector8)
        })
      }
      return userList
    },
    updateRecipientList() {
      if (this.recipients.length > 0) {
        for (let i = 0; i < this.recipients.length; i++) {
          this.emails.push(this.recipients[i].email)
        }
      }
    }
  },
  created() {
    // this.getEmailBlasts()
    this.getUsers()
  },
  mounted() {
    this.emailEditor = new Editor({
      // content: this.description,
      content: '',
      autoFocus: true,
      extensions: [
        new Blockquote(),
        new BulletList(),
        new CodeBlock(),
        new HardBreak(),
        new Heading({ levels: [1, 2, 3, 4, 5] }),
        new HorizontalRule(),
        new ListItem(),
        new OrderedList(),
        new TodoItem(),
        new TodoList(),
        new Link(),
        new Bold(),
        new Code(),
        new Italic(),
        new Strike(),
        new Underline(),
        new History(),
        new Image(), // https://github.com/scrumpy/tiptap/blob/master/examples/Components/Routes/Images/index.vue
      ],
      onUpdate: ({ getJSON, getHTML }) => {
        // this.json = getJSON()
        // this.html = getHTML()
        this.body = getHTML()
      },
    })
  },
  beforeDestroy() {
    this.emailEditor.destroy()
  },
  methods: {
    getUsers() {
      axios.get(`/api/people/?agency=${this.$store.getters.agencyID}`)
        .then(res => {
          this.users = res.data
          this.candidates = res.data.filter(user => {
            return user.is_candidate
          })
          this.employers = res.data.filter(user => {
            return user.is_employer
          })
          // for (let i = 0; i < this.users.length; i++) {
          //   // Regex to check for numbers in the input
          //   const numbers = /\d/g
          //   // Convert city names to lower case to make them easier to compare, remove any inputs that are not at least 3 characters, and remove inputs that have numbers
          //   if (!this.cities.includes(this.users[i].city.toLowerCase()) && this.users[i].city.length > 2 && !numbers.test(this.users[i].city)) {
          //     this.cities.push(this.users[i].city.toLowerCase())
          //   }
          // }
          // Sort list of cities in alphabetical order
          // this.cities.sort()
        })
    },
    // getEmailBlasts() {
    //   axios.get(`/api/emailblaster/?agency=${this.$store.getters.agencyID}`)
    //     .then(res => {
    //       this.emailBlasts = res.data
    //     })
    //     .catch(error => {
    //       console.log(error)
    //     })
    // },
    // showNewEmailModal() {
    //   this.$modal.show('new-email-modal')
    // },
    // getUsersByStatus() {
    //   axios.get(`/api/people/?agency=${this.$store.getters.agencyID}&status=${this.status}`, )
    //     .then(res => {
    //       this.recipients = res.data
    //       this.statusesSelected.push(this.status)
    //     })
    // },
    // saveEmail() {
    //   // axios.post(`/api/emailblaster/`, {
    //   let emailBlast ={
    //     recipients: this.emails,
    //     subject: this.subject,
    //     body: this.body,
    //     from_email: this.fromEmail,
    //     multiselect: this.statusesSelected,

    //     agency_owner: this.$store.getters.agencyName,
    //     agency: this.$store.getters.agencyID,
    //   }
    //   console.log(emailBlast)
    //   // })
    //     // .then(res => {
    //       // this.getEmailBlasts()
    //       this.$modal.hide('new-email-modal')
    //       this.$modal.show('success-modal')
    //     // })
    // },
    viewMailingList() {
      this.$modal.show('view-mailing-list-modal')
    },
    sendEmailBlast() {
      // this.candidateEmails = this.candidates.map(
      //   candidate => `${candidate.first_name} ${candidate.last_name} (${candidate.email})`
      // );

      for (var user in this.userList) {
        // console.log(this.userList[user].email)
        this.$store.dispatch('sendEmail',
          {
            subject: this.subject,
            message: this.body,
            from: this.fromEmail,
            email: this.userList[user].email,
            reply: this.fromEmail,
            userID: this.userList[user].id,
            html: true,
          }
        )
      }

      this.$modal.show('blastoff-modal')
    },

    // showDeleteModal() {
    //   this.$modal.show('delete-item-modal')
    // },
    // deleteItem() {
    //   axios.delete('/api/checklistitems/'.concat(this.item.id.toString()))
    //     .then(res => {
    //       this.$modal.hide('delete-item-modal')
    //       this.$modal.hide('add-checklist-modal')
    //       this.$modal.show('deleted-modal')
    //       this.getListItems()
    //     })
    //     .catch(error => console.log(error))
    // },
  }
}
</script>



// WEBPACK FOOTER //
// src/components/agents/functions/EmailBlaster.vue